const OPEN_NEW_TAB = 'open-new-tab'
const BROADCAST_CHANNEL = 'travcorp-webtab-activity'

class AnotherTabDetector {
  constructor(brandName) {
      this.isOpen = false

    // check if browser support BroadcastChannel API
    if ('BroadcastChannel' in self) {
      this.timestamp = Date.now()
      this.brandName = brandName
      this.msgParams = {
        timestamp: this.timestamp,
        brandName: this.brandName
      }
      this.channel = new BroadcastChannel(BROADCAST_CHANNEL)
      this.send()
    }
  }

  send(msg = OPEN_NEW_TAB) {
    if (this.channel) {
      this.channel.postMessage({...this.msgParams, msg})
    }
  }

  setUpListener(callback) {
    if (this.channel) {
      this.channel.addEventListener('message', (event) => {
        const {msg, timestamp, brandName} = event.data

        const isSameBrand = brandName === this.brandName
        const isNewerTab = timestamp > this.timestamp

        // The brandName check is intended to ensure full compliance with the behaviour in the production environment,
        // where we can only communicate in tabs of the same origin (same brand domain)
        // e.g. bookings.trafalgar.com or bookings.aatkings.com
        if (
          msg === OPEN_NEW_TAB
          && isSameBrand
          && isNewerTab
          && !this.isOpen
        ) {
            this.isOpen = true
            callback()
          }
      })
    }
  }
}

export default AnotherTabDetector